import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {

}
